let lan='Python'

function setLan(a){
    lan=a
}

function getLan(){
    return lan
}

export {setLan,getLan}